/**
 * Quản lý phiên "Login as User" (CTV/admin vào tài khoản user để hỗ trợ).
 *
 * Vì sao cần file này: localStorage dùng CHUNG theo origin, nên khi admin bấm
 * "Login as User", tab /login-as ghi đè access_token của CHÍNH họ trên
 * longhousee.com -> mọi tab khác (kể cả trang soạn bài blog) bỗng chạy bằng
 * token của user thường -> 403 "You don't have permission" mà không hiểu vì sao.
 *
 * Cách xử lý: cất token/user_info cũ vào key backup trước khi ghi đè, hiện banner
 * để thoát và trả lại phiên gốc.
 */

const TOKEN_KEY = 'access_token';
const USER_KEY = 'user_info';
const PREV_TOKEN_KEY = 'impersonate_prev_token';
const PREV_USER_KEY = 'impersonate_prev_user_info';
const FLAG_KEY = 'impersonate_user_id';

/** Bắt đầu phiên xem-hộ: backup phiên hiện tại rồi nạp token của user đích. */
export function startImpersonation(token, userId) {
    const prevToken = localStorage.getItem(TOKEN_KEY);
    // Chỉ backup khi đang có phiên khác (tránh ghi đè backup nếu bấm login-as 2 lần)
    if (prevToken && prevToken !== token && !localStorage.getItem(FLAG_KEY)) {
        localStorage.setItem(PREV_TOKEN_KEY, prevToken);
        const prevUser = localStorage.getItem(USER_KEY);
        if (prevUser) localStorage.setItem(PREV_USER_KEY, prevUser);
    }
    localStorage.setItem(TOKEN_KEY, token);
    if (userId) localStorage.setItem(FLAG_KEY, String(userId));
}

/**
 * Đang ở phiên xem-hộ hay không.
 * @returns {string|null} userId đang xem hộ
 */
export function getImpersonatedUserId() {
    const flag = localStorage.getItem(FLAG_KEY);
    if (!flag) return null;
    // Đã đăng xuất ở nơi khác -> cờ mồ côi, dọn luôn cho sạch
    if (!localStorage.getItem(TOKEN_KEY)) {
        clearImpersonation();
        return null;
    }
    return flag;
}

/** Thoát phiên xem-hộ: trả lại token/user_info gốc (nếu còn backup). */
export function stopImpersonation() {
    const prevToken = localStorage.getItem(PREV_TOKEN_KEY);
    const prevUser = localStorage.getItem(PREV_USER_KEY);
    if (prevToken) {
        localStorage.setItem(TOKEN_KEY, prevToken);
        if (prevUser) localStorage.setItem(USER_KEY, prevUser);
        else localStorage.removeItem(USER_KEY);
    } else {
        // Không có phiên gốc (mở thẳng link login-as ở trình duyệt sạch) -> đăng xuất
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    }
    clearImpersonation();
    return !!prevToken;
}

/** Xoá cờ + backup (không đụng tới phiên đang chạy). */
export function clearImpersonation() {
    localStorage.removeItem(FLAG_KEY);
    localStorage.removeItem(PREV_TOKEN_KEY);
    localStorage.removeItem(PREV_USER_KEY);
}
